import { Typography } from '@material-ui/core'
import React from 'react'
import MuiLink from "@material-ui/core/Link";
import { Link } from 'react-router-dom';

export const EdgePinchHistoricalModel = () => {
    return (
        <div>
            <Typography variant='h6'>
                Edge pinch procedure cannot be done via virtual traveler.
            </Typography>
            <p>
                Edge pinch procedure can be done under <MuiLink to="/operations/edge_upload/" component={Link}>
                    the Operations tab →
                    Edge Pinch Upload
                </MuiLink> .

            </p>
        </div>
    )
}


